import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.paymentMethod';

const translations = {
    'paymentMethod': 'Fizetési módok',
    'edit.title': 'Fizetési mód szerkesztése',
    'id.title': 'ID',
    'name.title': 'Megnevezés',
    'name.hint': 'Ezen a néven jelenik meg a webshopban is',
    'is_active.title': 'Aktív',
    'is_active.hint': 'Csak az aktív fizetési mód jelenik meg a webshopban',
    'sort.title': 'Sorrend',
    'short_description.title': 'Rövid leírás',
    'short_description_mpl_type.title': 'Rövid leírás (MPL)',
    'short_description.hint': 'Checkoutban jelenik meg',
    'cost.title': 'Utánvét díja (HUF)',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/PaymentMethod/lang/hu.ts